/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BackgroundElement from '../components/BackgroundElement';
import BannerCategory from '../components/BannerCategory';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerOverline from '../components/BannerOverline';
import BannerSubtitle from '../components/BannerSubtitle';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import Quotes from '../components/Quotes';
import AbstractLayout from './AbstractLayout';

export default class Swissness extends AbstractLayout {
	get key() {
		return 'swissness';
	}

	content() {
		const { banner } = this.attrs;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<BackgroundElement banner={banner} />

					<div className="BannerContentContainer Swissness-visual">
						<BannerImage banner={banner} />
					</div>

					<div className="BannerContentContainer Swissness-text">
						<div className="BannerContentContainer">
							<BannerTitle banner={banner} />
							<BannerTeaser banner={banner}>
								<Quotes banner={banner} />
							</BannerTeaser>
						</div>

						<div className="BannerContentContainer">
							<BannerSubtitle banner={banner} />
							<BannerOverline banner={banner} />
							<BannerCategory banner={banner} />
							<BannerLinkButton banner={banner} />
							<Disruptor banner={banner} />
						</div>
					</div>
				</div>
			</LinkWrapper>
		);
	}
}
